import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import AddPlayer from '../../components/AddPlayer';

const SELECTOR_TRIGGER_BUTTON = '.js-trigger-add-player';
const SELECTOR_ADD_PLAYER_MODAL = '#add-player-modal';
const SELECTOR_ADD_PLAYER_COMPONENT = '.lta-add-player';
const SELECTOR_PLAYER_LIST = '.add-player-list';

const CLICK_EVENT = 'click';

class AddPlayerPage {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.js-add-player-section');
		this.playersData = [];
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get playersData() {
		return this._playersData;
	}
	set playersData(data) {
		this._playersData = data;
		if(this._playersData.length > 0) {
			this.renderPlayerList();
		}
	}

	init() {
		this.addPlayerTriggerButton = SelectorEngine.findOne(SELECTOR_TRIGGER_BUTTON, this._wrapper);
		this.addPlayerModal = new Modal(SelectorEngine.findOne(SELECTOR_ADD_PLAYER_MODAL, this._wrapper));
		this.addPlayerComponent = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_COMPONENT, this._wrapper);
		this.playerList = SelectorEngine.findOne(SELECTOR_PLAYER_LIST, this._wrapper);

		this.addPlayer = new AddPlayer(this.addPlayerComponent);
		this.addPlayer.onExitClick(() => {
			this.addPlayerModal.hide();
		});
		this.addPlayer.onSubmitClick((playerObject) => {
			this.addPlayerModal.hide();
			this.playersData = [
				...this.playersData,
				playerObject
			]
		});

		EventHandler.on(this.addPlayerTriggerButton, CLICK_EVENT, () => {
			this.addPlayerModal.show();
		});
	}

	renderPlayerList() {
		this.playerList.innerHTML = this.playersData.map((data) => this.renderPlayerCard(data)).join('');
	}

	getAge(dateString) {
		var ageInMilliseconds = new Date() - new Date(dateString);
		return Math.floor(ageInMilliseconds/1000/60/60/24/365);
	 }

	renderPlayerCard(playerData) {
		return `
			<div class="lta-form-check lta-form-checkbox u-hstack u-my-1 md:u-mr-3 g-col-12 g-col-md-6 u-h-100 u-my-2">
				<input 
					class="lta-form-check-input u-mr-2" 
					type="checkbox" 
					name="player-details" 
					value="" 
					aria-label="" />
				<div class="u-bg-background-blue u-px-3 u-py-2 u-rounded u-h-100">
					<div class="u-caption1 u-text-grey-lta">${playerData.firstName} ${playerData.lastName}</div>
					<div class="u-body1 u-text-grey-lta">Age: ${this.getAge(playerData.birthDate)}</div>
					<div class="u-body1 u-text-grey-lta">${playerData.gender}</div>
				</div>
			</div>`;
	}
}

const globalAddPlayerPage = new AddPlayerPage();
export default globalAddPlayerPage;
